import { render, staticRenderFns } from "./NsDynamicFieldset.vue?vue&type=template&id=424ff21f&scoped=true&"
import script from "./NsDynamicFieldset.vue?vue&type=script&lang=js&"
export * from "./NsDynamicFieldset.vue?vue&type=script&lang=js&"
import style0 from "./NsDynamicFieldset.vue?vue&type=style&index=0&id=424ff21f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../packages/aem/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "424ff21f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/workspace/webcomponents-ui - release-finish/src/main/content/webcomponents/js/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('424ff21f')) {
      api.createRecord('424ff21f', component.options)
    } else {
      api.reload('424ff21f', component.options)
    }
    module.hot.accept("./NsDynamicFieldset.vue?vue&type=template&id=424ff21f&scoped=true&", function () {
      api.rerender('424ff21f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "node_modules/@nuskin/design-components/src/components/ns-dynamic-fieldset/NsDynamicFieldset.vue"
export default component.exports